import React, { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import solisPowerApi from "../../api/solisPowerApi";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader
} from 'react-bs-datatable';
import moment from 'moment';
import Main from "../../components/layout/Main";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
//React Icon
import { BsChevronRight } from "react-icons/bs";
import { BrowserView } from "react-device-detect";
import InfoPill from "../InfoPill";
import { formatDate, formatDateForView } from '../../utils/helper';

const ReportList = () => {


  const [body, setBody] = useState([]);

  useEffect(() => {
    async function init() {
      const reports = await solisPowerApi.fetchReports();
      if (reports)
        setBody(reports);
    }
    init();
  }, []);

  const header = [
    {
      title: 'Report Name', prop: 'name', isFilterable: true,
      cell: (row) => (
        <Link
          to={"/reports/" + row.id}
          state={row}
        >
          {row.name}
        </Link>
      )
    },
    //formatDateForView added by shahir hussain 27-08-2025
    { title: 'Created Date', prop: 'createddate', cell: (row) => (row?.createddate ? formatDateForView(row.createddate) : ''), isFilterable: true },
    { title: 'LastModified Date', prop: 'lastmodifieddate', cell: (row) => (row.lastmodifieddate ? formatDateForView(row.lastmodifieddate) : ''), isFilterable: true },
  ]

  const labels = {
    beforeSelect: " "
  }
  return (
    <Container>
      <Row className="">
        <Col lg={12} className="">
          {body ?
            <DatatableWrapper body={body} headers={header} paginationOptionsProps={{
              initialState: {
                rowsPerPage: 50,
                options: [5, 10, 15, 20, 30, 50]
              }
            }}>
              <Row className="align-items-end ">
                <Col
                  md={3}
                >
                  <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
                </Col>
                <Col
                  md={1}
                >
                  <PaginationOptions labels={labels} />
                </Col>
                <Col className="py-1"  >
                  <BrowserView>
                    <div className="d-flex py-1 px-2 ">
                      <InfoPill
                        left="Total"
                        right={body?.length}
                        rightClasses="bg-custom text-white border-white fw-bold"
                        leftClasses="bg-white  fw-bold "
                      />
                    </div>
                  </BrowserView>
                </Col>
                {/* <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                > */}
                {/* <Button className="btn-sm" variant="outline-primary" >New Report</Button> */}
                {/* </Col> */}
              </Row>
              <div className="table-scroll my-3">
                <Table striped className="shadow rounded sm my-4">
                  <TableHeader classes={{ th: 'bg-custom text-white sticky-header' }} />
                  <TableBody />
                </Table>
              </div>
              <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
            </DatatableWrapper> : ''}
        </Col>
      </Row>
    </Container>

  )
}

export default ReportList
